import React, { useMemo, useState } from 'react'
import { Select, Space } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { PeriodGroup } from '../../../types/periodGroup/PeriodGroup'
import { PeriodGroupSelection } from '../../../redux/context/filters/types'
import { periodGroupsFromFiscalYears, periodLength } from '../../../utils/periodGroups/utils'
import { useCtxReportableFiscalYears } from '../../fiscalYear/hooks/useCtxReportableFiscalYears'
import PeriodTabFooter from './PeriodTabFooter'

interface FiscalYearTabProps {
  initialSelection?: PeriodGroupSelection & { type: 'fiscalYear' }
  onSubmit: (periodGroups: PeriodGroup[], selection: PeriodGroupSelection) => void
  onClear: () => void
}

const FiscalYearTab: React.FC<FiscalYearTabProps> = ({ initialSelection, onSubmit, onClear }) => {
  const { t } = useTranslation()
  const { data: reportableFiscalYears } = useCtxReportableFiscalYears()

  const [periodStart, setPeriodStart] = useState<number | undefined>(initialSelection?.startMonth)
  const [periodEnd, setPeriodEnd] = useState<number | undefined>(initialSelection?.endMonth)

  const monthOptions = useMemo(
    () =>
      dayjs.months().map((month, i) => ({
        label: month,
        value: i
      })),
    []
  )

  const handleSubmit = () => {
    if (periodStart === undefined || periodEnd === undefined) return
    const length = periodLength(periodStart, periodEnd)
    const partialFiscalYears = periodGroupsFromFiscalYears(periodStart, length, reportableFiscalYears || [])
    onSubmit(partialFiscalYears, { type: 'fiscalYear', startMonth: periodStart, endMonth: periodEnd })
  }

  return (
    <div>
      <Space.Compact block>
        <Select
          showSearch
          optionFilterProp="label"
          style={{ width: '50%' }}
          allowClear
          placeholder={t('periodSelect:start')}
          options={monthOptions}
          value={periodStart}
          onChange={setPeriodStart}
        />
        <Select
          showSearch
          optionFilterProp="label"
          style={{ width: '50%' }}
          allowClear
          placeholder={t('periodSelect:end')}
          options={monthOptions}
          value={periodEnd}
          onChange={setPeriodEnd}
        />
      </Space.Compact>
      <PeriodTabFooter onSubmit={handleSubmit} onClear={onClear} />
    </div>
  )
}

export default FiscalYearTab
